<div class="overlay-taslsoli">
    <div class="popup">
      <h2>اختيار المخطط</h2>

      <!-- <div class="overlay-taslsoli">
        <div class="popup">
          <h2>اختيار قطعة الأرض</h2>
          <div class="input-field">
            <label for="baladeya"> البلدية </label>
            <select id="baladeya" (change)="onBaladeyaNameChange($event)" (search)="queryPlanNames($event.target.value)">
              <option value="">All</option>
              <option *ngFor="let option of baladeyaNameOptions" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>
          <div class="input-field">
            <label for="planNumber"> رقم المخطط </label>
            <input id="planNumber" type="text" (keyup)="liveSearchPlanNumber($event.target.value)" placeholder="Enter Plan Number">
          </div>
          <div class="input-field">
            <label for="planName"> اسم المخطط </label>
            <span>{{ planName }}</span>
          </div>
          <div class="input-field">
            <label for="neighborhoodName"> اسم الحي </label>
            <span>{{ neighborhoodName }}</span>
          </div>
        </div>
      </div> -->
      

      <div class="input-field">
        <label for="baladeya"> البلدية </label>
       
        <select id="baladeya" (change)="onBaladeyaNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of baladeyaNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    
      <div class="input-field">
        <label for="planName"> اسم الحي </label>
       
        <select id="planName" (change)="onNeighNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of neighNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
     
      <div class="input-field">
        <label for="planName"> اسم المخطط </label>
       
        <select id="planName" (change)="onPlanNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of planNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
       <!-- <div class="input-field">
        <label for="parcelno"> رقم القطعة </label>
        
        <select id="parcelno" (change)="onParcelNoChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of parcelNoOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>  -->
    </div>
  </div>
  